module.exports = __webpack_public_path__ + "static/media/mek_b.b4f48c24.png";